/* SIDDAMENT search enhancer.
 * Hooks into Dawn's <predictive-search> input and augments results with:
 *   - Intent → material chips (helmet → PLA, outdoor → ASA/PETG)
 *   - SKU lookups (PRU.001, PRO.C13, etc.)
 *   - Quick "Show all X" filter chips
 * Doesn't replace native search — adds a panel above it.
 */
(function () {
  if (window.__siddSearchEnhanced) return;
  window.__siddSearchEnhanced = true;

  // -------------------- INTENT MAP --------------------
  // Word → material recommendations + brief reason
  var INTENT = [
    [/\b(helmet|cosplay|armor|armour|sword|prop|costume)\b/i, 'PLA',  'cosplay: easy, large prints'],
    [/\b(bracket|mount|holder|enclosure|housing)\b/i,        'PETG', 'brackets: tough, weather-friendly'],
    [/\b(gear|cog|pulley|bushing|bearing|wear)\b/i,          'Nylon','gears: wear-resistant'],
    [/\b(outdoor|garden|outside|patio|sun|weather)\b/i,      'ASA',  'outdoors: UV-stable'],
    [/\b(uv|sunlight|direct sun)\b/i,                        'ASA',  'UV resistant'],
    [/\b(engine|car|dashboard|hot|automotive|heat)\b/i,      'ASA',  'heat resistant'],
    [/\b(phone case|gasket|grip|sole|flexible|bend|rubber)\b/i,'TPU','flexible'],
    [/\b(mini|miniature|figurine|warhammer|tabletop|d&d)\b/i,'PLA',  'minis: fine detail'],
    [/\b(beginner|new|first|easy|starter)\b/i,               'PLA',  'beginner friendly'],
    [/\b(strong|tough|durable|impact)\b/i,                   'PCTG', 'tough plastic'],
    [/\b(carbon fib|carbon fiber|carbon fibre|cf)\b/i,       'CF',   'carbon-fibre reinforced'],
    [/\b(glass fib|glass fiber|glass fibre|gf)\b/i,          'GF',   'glass-fibre reinforced'],
    [/\b(matte)\b/i,                                         'Matte','matte finish'],
    [/\b(silk)\b/i,                                          'Silk', 'silk finish'],
    [/\b(sparkle|glitter)\b/i,                               'Sparkle','sparkle finish'],
    [/\b(gradient)\b/i,                                      'Gradient','gradient finish'],
    [/\b(translucent|transparent|clear)\b/i,                 'Translucent','see-through'],
    [/\b(glow)\b/i,                                          'Glow-in-the-dark','glow finish'],
  ];

  // SKU pattern detection
  var SKU_RX = /\b(PRU|PRO\.[CR]?|[1-9]\.\d{1,3}|\d{1,2}\.\d{1,3})\d*\b/i;

  // Material → collection slug for "Browse all" links
  var MAT_COLLECTION = {
    PLA: 'all-pla', HTPLA: 'all-htpla', PETG: 'all-petg', PCTG: 'all-pctg',
    ABS: 'all-abs', ASA: 'all-asa', PC: 'all-pc', Nylon: 'all-nylon', TPU: 'all-tpu',
    CF: 'all', GF: 'all', // fallback to filtered all
    Matte: 'all', Silk: 'all', Sparkle: 'all', Gradient: 'all',
    Translucent: 'all', 'Glow-in-the-dark': 'all',
  };

  var dataset = null;
  var datasetPromise = null;
  function loadDataset() {
    if (dataset) return Promise.resolve(dataset);
    if (datasetPromise) return datasetPromise;
    var url = window.__siddFilamentsUrl || '/cdn/shop/t/30/assets/filaments.json';
    datasetPromise = fetch(url, { cache: 'force-cache', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { dataset = d; return d; })
      .catch(function () { return []; });
    return datasetPromise;
  }

  function findIntents(query) {
    var hits = [];
    var seen = {};
    INTENT.forEach(function (row) {
      if (row[0].test(query)) {
        var key = row[1];
        if (!seen[key]) { seen[key] = 1; hits.push({ tag: row[1], reason: row[2] }); }
      }
    });
    return hits;
  }

  function findBySku(query) {
    if (!dataset) return [];
    var q = query.trim().toUpperCase();
    if (q.length < 3) return [];
    var hits = [];
    for (var i = 0; i < dataset.length && hits.length < 4; i++) {
      var p = dataset[i];
      if (p.sku && p.sku.toUpperCase().indexOf(q) >= 0) hits.push(p);
    }
    return hits;
  }

  function buildEnhancement(query) {
    var wrap = document.createElement('div');
    wrap.className = 'sidd-search-enhance';

    var intents = findIntents(query);
    var skuHits = findBySku(query);

    if (intents.length === 0 && skuHits.length === 0) return null;

    if (intents.length) {
      var intentBox = document.createElement('div');
      intentBox.className = 'sidd-search-section';
      intentBox.innerHTML = '<div class="sidd-search-label">Suggested match</div>';
      var chips = document.createElement('div');
      chips.className = 'sidd-search-chips';
      intents.forEach(function (it) {
        var slug = MAT_COLLECTION[it.tag] || 'all';
        var url = slug === 'all'
          ? '/collections/all?filter.p.tag=' + encodeURIComponent(it.tag)
          : '/collections/' + slug;
        var a = document.createElement('a');
        a.className = 'sidd-search-chip';
        a.href = url;
        a.innerHTML = '<strong>' + it.tag + '</strong> <span>' + it.reason + '</span>';
        chips.appendChild(a);
      });
      intentBox.appendChild(chips);
      wrap.appendChild(intentBox);
    }

    if (skuHits.length) {
      var skuBox = document.createElement('div');
      skuBox.className = 'sidd-search-section';
      skuBox.innerHTML = '<div class="sidd-search-label">SKU match</div>';
      var list = document.createElement('div');
      list.className = 'sidd-search-skus';
      skuHits.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'sidd-search-sku';
        a.href = '/products/' + p.handle;
        a.innerHTML =
          '<img src="' + p.image + '" alt="" loading="lazy">' +
          '<div class="sidd-search-sku-body">' +
            '<span class="sidd-search-sku-title">' + escapeHtml(p.title) + '</span>' +
            '<span class="sidd-search-sku-meta">SKU ' + escapeHtml(p.sku) + ' · $' + p.price.toFixed(2) + '</span>' +
          '</div>';
        list.appendChild(a);
      });
      skuBox.appendChild(list);
      wrap.appendChild(skuBox);
    }
    return wrap;
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }[c];
    });
  }

  // -------------------- POLLING APPROACH --------------------
  // Simple, reliable: poll the predictive-search input every 250ms; when the
  // value changes, inject (or remove) our chunk. Re-injects after Dawn
  // replaces the results panel (because we always check on each tick).
  var lastValue = null;
  var inFlight = false;

  function tick() {
    if (inFlight) return;

    // First: remove ALL stale enhancement chunks anywhere in the document
    // (covers multiple predictive-search elements, stale state across opens).
    var allChunks = document.querySelectorAll('.sidd-search-enhance');

    // Find the currently visible predictive-search input
    var visibleInput = null;
    var visiblePS = null;
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      if (visibleInput) return;
      var inputs = ps.querySelectorAll('input[type="search"], input[name="q"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].offsetParent !== null) {
          visibleInput = inputs[i];
          visiblePS = ps;
          break;
        }
      }
    });
    if (!visibleInput) {
      // No active search — wipe any leftover chunks
      allChunks.forEach(function (e) { e.remove(); });
      lastValue = null;
      return;
    }

    var q = (visibleInput.value || '').trim();

    if (q.length < 2) {
      allChunks.forEach(function (e) { e.remove(); });
      lastValue = q;
      return;
    }

    // If query unchanged AND exactly one chunk in the visible PS, skip
    var resultsContainer = visiblePS.querySelector('#predictive-search-results') || visiblePS;
    var hereChunks = resultsContainer.querySelectorAll(':scope > .sidd-search-enhance');
    if (q === lastValue && hereChunks.length === 1 && allChunks.length === 1) return;

    // Wipe everything (stale chunks elsewhere + duplicates here)
    allChunks.forEach(function (e) { e.remove(); });
    lastValue = q;

    inFlight = true;
    loadDataset().then(function () {
      try {
        // Re-fetch visible input (DOM may have changed)
        var ps2 = null, rc = null;
        document.querySelectorAll('predictive-search').forEach(function (ps) {
          if (ps2) return;
          var inputs = ps.querySelectorAll('input[type="search"], input[name="q"]');
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].offsetParent !== null) {
              ps2 = ps;
              rc = ps.querySelector('#predictive-search-results') || ps;
              break;
            }
          }
        });
        if (!ps2 || !rc) return;
        // Final dedupe
        document.querySelectorAll('.sidd-search-enhance').forEach(function (e) { e.remove(); });
        // Re-read query
        var freshInput = ps2.querySelector('input[type="search"], input[name="q"]');
        var freshQ = freshInput ? (freshInput.value || '').trim() : '';
        if (freshQ.length < 2) return;
        var enhancement = buildEnhancement(freshQ);
        if (!enhancement) return;
        if (rc.firstChild) rc.insertBefore(enhancement, rc.firstChild);
        else rc.appendChild(enhancement);
      } finally {
        inFlight = false;
      }
    });
  }

  function attach() {
    if (window.__siddSearchPolling) return true;
    window.__siddSearchPolling = setInterval(tick, 250);
    return true;
  }

  if (document.readyState !== 'loading') attach();
  document.addEventListener('DOMContentLoaded', attach);
  // Predictive-search may mount dynamically — observe and re-attach
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { attach(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
